export default "__VITE_ASSET__C0S8rX02__"